// src/components/AnimatedSearchExample.js
import React, { useState, useEffect, useMemo } from 'react';

const AnimatedSearchExample = () => {
  const examples = useMemo(() => [
    "zombies for two players",
    "a card game for kids",
    "a party game for 10 players",
    "a cooperative fantasy game",
    "quick strategy games"
  ], []);
  
  const [currentExample, setCurrentExample] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [phase, setPhase] = useState("typing"); // "typing", "pause", or "erasing"
  
  useEffect(() => {
    let timeout;
    
    if (phase === "typing") {
      if (charIndex < examples[currentIndex].length) {
        timeout = setTimeout(() => {
          setCurrentExample(prev => prev + examples[currentIndex][charIndex]);
          setCharIndex(charIndex + 1);
        }, 80); // Regular typing speed (80ms per character)
      } else {
        // Finished typing - move to pause phase
        setPhase("pause");
      }
    } 
    else if (phase === "pause") {
      // Pause with full text displayed before erasing
      timeout = setTimeout(() => {
        setPhase("erasing");
      }, 1000); // 1 second pause
    } 
    else if (phase === "erasing") {
      if (currentExample.length > 0) {
        timeout = setTimeout(() => {
          setCurrentExample(prev => prev.slice(0, -1));
        }, 15); // Erasing speed per character
      } else {
        // Finished erasing - prepare for next example
        setPhase("typing");
        setCharIndex(0);
        setCurrentIndex((currentIndex + 1) % examples.length);
      }
    }
    
    return () => clearTimeout(timeout);
  }, [currentExample, charIndex, currentIndex, examples, phase]);

  return (
    <span className="text-blue-400 text-xl">
      {currentExample}
      <span className="animate-pulse">|</span>
    </span>
  );
};

export default AnimatedSearchExample;